import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { Sorting } from '@treetop/shared/model';

import { createGuidelineParams } from './create-guidelines-params';
import { SmartbookFilter } from '../entities/filter';
import { GuidelineSummary } from '../entities/guideline-summary';
import { Pagination } from '../entities/pagination';

interface PaginatedResponse<T> extends Pagination {
  list: T[];
}

type GetGuidelinesResponse = PaginatedResponse<GuidelineSummary>;
type GetRecentlyViewedResponse = GuidelineSummary[];

@Injectable({
  providedIn: 'root',
})
export class GuidelinesHttpService {
  private http = inject(HttpClient);

  baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/smart-book`;

  get(filter: SmartbookFilter, pagination: Pagination, sorting: Sorting): Observable<GetGuidelinesResponse> {
    const params = createGuidelineParams(filter, pagination, sorting);

    return this.http.get<GetGuidelinesResponse>(`${this.baseUrl}/`, { params });
  }

  getRecentlyViewed(count = 4): Observable<GetRecentlyViewedResponse> {
    const params = new HttpParams().set('count', count);

    return this.http.get<GetRecentlyViewedResponse>(`${this.baseUrl}/recently-viewed`, { params });
  }
}
